import React from 'react';
import { Card, OverlayTrigger, Tooltip, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
// import TransitTimeChart from './TransitTimeChart';
import PropTypes from 'prop-types';

const TransitTime = ({ data, title }) => {
  const parts = title.includes('Emissão') 
              ? title.split('Emissão') 
              : title.split('Liberação');
  return (
    <Card className="h-md-100">
      <Card.Header className="pb-0">
        <Row className="">
          <Col xs={12} className="align-items-center">
            <h6 className="mb-0 mt-3">  {parts[0]}
            <br />{parts[1] ? (title.includes('Emissão') ? 'Emissão' : 'Liberação') + parts[1] : ''} </h6>

            {/* <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip style={{ position: 'fixed' }}>
                  {' '}
                  A base sugerida para o cálculo é dos últimos 50 processos
                </Tooltip>
              }
            >
              <div className="ml-auto">
                <FontAwesomeIcon
                  icon={['far', 'question-circle']}
                  transform="shrink-1"
                  className="text-400 mt-3"
                  id="avgCallTooltip"
                />
              </div>
            </OverlayTrigger> */}
          </Col>
        </Row>
      </Card.Header>
      <Card.Body
        as={Flex}
        alignItems="end"
        justifyContent="between"
        className="pt-0"
      >
        <div>
          <h4 className="fw-normal text-700 mb-4 lh-1 align-items-center">{data} &nbsp;Dias</h4>
          {/* <p className="fs--2 fw-semi-bold text-500 mb-0">Based on 50 calls</p> */}
        </div>
        {/* <div className="ps-0 mt-n3">
          <TransitTimeChart style={{ height: '3rem', width: '9rem' }} />
        </div> */}
      </Card.Body>
    </Card>
  );
};

TransitTime.propTypes = {
  data: PropTypes.string,
  title: PropTypes.string
};

export default TransitTime;
